import { accountingApi } from '../../../../config/apiClient';
import { ACCOUNTING_API } from '../../../../config/api';

// DTO types
export interface InventoryWarehouseDto {
  id: string;
  companyId: string;
  name: string;
  address?: string;
  description?: string;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
  isDeleted: boolean;
  branchesId?: string | null;
  warehouseType?: string;
  locationModel?: string;
  totalCapacity?: number;
  defaultRoutingStrategy?: string;
}

export interface CreateInventoryWarehouseDto {
  companyId: string;
  name: string;
  address?: string;
  description?: string;
  isDefault: boolean;
  branchesId?: string | null;
  warehouseType?: string;
  locationModel?: string;
  totalCapacity?: number;
  defaultRoutingStrategy?: string;
}

export interface UpdateInventoryWarehouseDto {
  companyId: string;
  id: string;
  name: string;
  address?: string;
  description?: string;
  isDefault: boolean;
  isActive: boolean;
  branchesId?: string | null;
  warehouseType?: string;
  locationModel?: string;
  totalCapacity?: number;
  defaultRoutingStrategy?: string;
}

/**
 * Depo Service - SQL CRUD işlemleri
 */
export class WarehouseService {
  /**
   * Tüm depoları getir
   */
  static async getAllWarehouses(companyId: string): Promise<InventoryWarehouseDto[]> {
    try {
      console.log('🔍 [WAREHOUSE SERVICE] Depolar yükleniyor:', companyId);
      const response = await accountingApi.get<InventoryWarehouseDto[]>(
        ACCOUNTING_API.INVENTORY_WAREHOUSES
      );
      const list = Array.isArray(response.data) ? response.data : [];
      const normalized = list.map((w: any) => ({
        id: w.id || w.Id,
        companyId: w.companyId || w.CompanyId,
        name: w.name || w.Name || '',
        address: w.address || w.Address,
        description: w.description || w.Description,
        isDefault: w.isDefault ?? w.IsDefault ?? false,
        createdAt: w.createdAt || w.CreatedAt || '',
        updatedAt: w.updatedAt || w.UpdatedAt || '',
        isActive: w.isActive ?? w.IsActive ?? true,
        isDeleted: w.isDeleted ?? w.IsDeleted ?? false,
        branchesId: w.branchesId || w.BranchesId || null,
        warehouseType: w.warehouseType || w.WarehouseType || 'Normal',
        locationModel: w.locationModel || w.LocationModel,
        totalCapacity: w.totalCapacity ?? w.TotalCapacity,
        defaultRoutingStrategy: w.defaultRoutingStrategy || w.DefaultRoutingStrategy,
      })) as InventoryWarehouseDto[];
      console.log('✅ [WAREHOUSE SERVICE] Depolar başarıyla yüklendi:', normalized.length);
      return normalized;
    } catch (error: any) {
      console.error('❌ [WAREHOUSE SERVICE] Depolar yüklenirken hata:', error);
      throw new Error(error.response?.data?.message || 'Depolar yüklenirken hata oluştu');
    }
  }

  /**
   * Yeni depo oluştur
   */
  static async createWarehouse(warehouse: CreateInventoryWarehouseDto): Promise<InventoryWarehouseDto> {
    try {
      console.log('🔍 [WAREHOUSE SERVICE] Yeni depo oluşturuluyor:', warehouse);
      const response = await accountingApi.post<InventoryWarehouseDto>(
        ACCOUNTING_API.INVENTORY_WAREHOUSE_CREATE,
        warehouse
      );
      console.log('✅ [WAREHOUSE SERVICE] Depo başarıyla oluşturuldu:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('❌ [WAREHOUSE SERVICE] Depo oluşturma hatası:', error);
      throw new Error(error.response?.data?.message || 'Depo oluşturulurken hata oluştu');
    }
  }

  /**
   * Depo güncelle
   */
  static async updateWarehouse(warehouse: UpdateInventoryWarehouseDto): Promise<InventoryWarehouseDto> {
    try {
      console.log('🔍 [WAREHOUSE SERVICE] Depo güncelleniyor:', warehouse);
      const response = await accountingApi.post<InventoryWarehouseDto>(
        ACCOUNTING_API.INVENTORY_WAREHOUSE_UPDATE(warehouse.id),
        warehouse
      );
      console.log('✅ [WAREHOUSE SERVICE] Depo başarıyla güncellendi:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('❌ [WAREHOUSE SERVICE] Depo güncelleme hatası:', error);
      throw new Error(error.response?.data?.message || 'Depo güncellenirken hata oluştu');
    }
  }

  /**
   * Depo sil
   */
  static async deleteWarehouse(companyId: string, warehouseId: string): Promise<void> {
    try {
      console.log('🔍 [WAREHOUSE SERVICE] Depo siliniyor:', warehouseId);
      await accountingApi.post(
        ACCOUNTING_API.INVENTORY_WAREHOUSE_DELETE(warehouseId)
      );
      console.log('✅ [WAREHOUSE SERVICE] Depo başarıyla silindi');
    } catch (error: any) {
      console.error('❌ [WAREHOUSE SERVICE] Depo silme hatası:', error);
      throw new Error(error.response?.data?.message || 'Depo silinirken hata oluştu');
    }
  }
}

